<template>
    <!-- <Breadcrumbs main="Setting" mains="PurchaseDestination Management" title="PurchaseDestination Management" /> -->
    <div class="container-fluid default-dashboard">
        <div class="card">
            <div class="card-header">
                <div class="d-flex justify-content-between align-items-center">
                    <h5>PurchaseDestination List</h5>
                    <button class="btn btn-primary" @click="openModal()">
                        <i class="fa fa-plus"></i> Add Purchase Destination
                    </button>
                </div>
            </div>
            <div class="card-body">
                <DataTable
                    :headers="headers"
                    :items="purchaseDestinations"
                    :loading="loading"
                    :total="total"
                    :params="params"
                    @update:params="updateParams"
                >
                    <template #item.actions="{ item }">
                        <button class="btn btn-sm btn-warning me-2" @click="editPurchaseDestination(item as PurchaseDestination)">
                            <i class="fa fa-edit"></i>
                        </button>
                        <button class="btn btn-sm btn-danger" @click="deletePurchaseDestination(item as PurchaseDestination)">
                            <i class="fa fa-trash"></i>
                        </button>
                    </template>
                </DataTable>
            </div>
        </div>
    </div>

    <div class="modal fade bd-example-modal-lg" id="purchaseDestinationModal" tabindex="-1" ref="modalRef" aria-labelledby="purchaseDestinationModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <h3 class="modal-header justify-content-center border-0">{{ modalTitle }}</h3>
                <div class="modal-body">
                    <div class="row">
                        <div class="row">
                            <div class="col-md-6 mb-2">
                                <label class="form-label col-form-label">Divisi</label>
                                <select v-model="form.divisi" class="form-select">
                                    <option :value="null" disabled>Select Divisi</option>
                                    <option v-for="option in divisiOptions" :key="option.ID" :value="option">
                                        {{ option.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-6 mb-2">
                                <label class="form-label col-form-label">DivisiTeam</label>
                                <select v-model="form.divisi_team" class="form-select">
                                    <option :value="null" disabled>Select DivisiTeam</option>
                                    <option v-for="option in divisiTeamOptions" :key="option.ID" :value="option">
                                        {{ option.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-6 mb-2">
                            <label class="form-label col-form-label">Code</label>
                            <input v-model="form.code" type="text" class="form-control" required>
                        </div>
                        <div class="col-md-6 mb-2">
                            <label class="form-label col-form-label">Name</label>
                            <input v-model="form.name" type="text" class="form-control" required>
                        </div>
                        <div class="row">
                            <div class="col-md-4 mb-2">
                                <label class="form-label col-form-label">Province</label>
                                <select v-model="form.province" class="form-select">
                                    <option :value="null" disabled>Select Province</option>
                                    <option v-for="option in provinceOptions" :key="option.province" :value="option.province">
                                        {{ option.province }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-4 mb-2">
                                <label class="form-label col-form-label">City</label>
                                <select v-model="form.city" class="form-select">
                                    <option :value="null" disabled>Select City</option>
                                    <option v-for="option in cityOptions" :key="option.city" :value="option.city">
                                        {{ option.city }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-4 mb-2">
                                <label class="form-label col-form-label">Area</label>
                                <select v-model="form.area" class="form-select">
                                    <option :value="null" disabled>Select Area</option>
                                    <option v-for="option in areaOptions" :key="option.area" :value="option.area">
                                        {{ option.area }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-danger" type="button" @click="closeModal">Cancel</button>
                    <button class="btn btn-primary" type="submit" @click="savePurchaseDestination">Save</button>
                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts" setup>
import { ref, reactive, onMounted, watch, nextTick } from 'vue'
import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import DataTable from '@/components/table/Datatable.vue'
import { Modal } from 'bootstrap'
const divisiOptions = ref<{ ID: any, name: string }[]>([])
const divisiTeamOptions = ref<{ ID: any, name: string }[]>([])
const provinceOptions = ref<{ province: string, city:string, area: string }[]>([])
const cityOptions = ref<{ province: string, city:string, area: string }[]>([])
const areaOptions = ref<{ province: string, city:string, area: string }[]>([])
const isEditing = ref(false) // <-- Add this line

// {{ Define PurchaseDestination interface }}
interface PurchaseDestination {
    ID: number | null;
    code: string;
    name: string;
    divisi: any;
    divisi_team: any;
    province: any;
    city: any;
    area: any;
}

const headers = [
    { text: 'Code', value: 'code' },
    { text: 'Name', value: 'name' },
    { text: 'City', value: 'city' },
    { text: 'Actions', value: 'actions' }
]

// {{ Apply types to refs and reactive objects }}
const purchaseDestinations = ref<PurchaseDestination[]>([])
const loading = ref(false)
const total = ref(0)
const params = reactive<DataTableParams>({
    page: 1,
    size: 10,
    search: ''
})

const modalTitle = ref('')
const form = reactive<PurchaseDestination>({
    ID: null,
    code: '',
    name: '',
    divisi: null,
    divisi_team: null,
    province: null,
    city: null,
    area: null
})

// Add this data data array
const dataPurchaseDestinations: PurchaseDestination[] = []
import * as master from "@/api/services/MasterRequest";

const fetchDivisi = async () => {
    loading.value = true
    try {
        // Simulate API delay
        const resp = await master.postRequest("/divisi/list", {page:1, size:10000,search:''});
        divisiOptions.value = resp.data;
    } catch (error) {
        toast.error('Failed to fetch purchaseDestinations')
    }
    loading.value = false
}

const fetchProvince = async () => {
    loading.value = true
    try {
        // Simulate API delay
        const resp = await master.postRequest("/destination/province", {page:1, size:10000,search:''});
        provinceOptions.value = resp.data;
    } catch (error) {
        toast.error('Failed to fetch purchaseDestinations')
    }
    loading.value = false
}

const fetchCity = async (province: string) => {
    loading.value = true
    try {
        const resp = await master.postRequest("/destination/city", {
            page: 1,
            size: 10000,
            search: province
        });
        cityOptions.value = resp.data;
    } catch (error) {
        toast.error('Failed to fetch cities')
    }
    loading.value = false
}

const fetchArea = async (city: string) => {
    loading.value = true
    try {
        const resp = await master.postRequest("/destination/area", {
            page: 1,
            size: 10000,
            search: city
        });
        areaOptions.value = resp.data;
    } catch (error) {
        toast.error('Failed to fetch cities')
    }
    loading.value = false
}

const fetchPurchaseDestinations = async () => {
    loading.value = true
    try {
        // Simulate API delay
        const resp = await master.postRequest("/purchaseDestination/list", {...params});
        purchaseDestinations.value = resp.data
        total.value = resp.total

    } catch (error) {
        toast.error('Failed to fetch purchaseDestinations')
    }
    loading.value = false
}

// {{ Add type annotation for newParams }}
const updateParams = (newParams: Partial<DataTableParams>) => {
    Object.assign(params, newParams)
    fetchPurchaseDestinations()
}

const modalRef = ref<HTMLElement | null>(null) // Type the ref
let bsModal: any | null = null // Type the bootstrap modal instance as any since Modal namespace can't be used directly

// View modal state
const viewModalRef = ref<HTMLElement | null>(null)
let bsViewModal: any | null = null
const selectedPurchaseDestination = ref<PurchaseDestination | null>(null)

onMounted(() => {
    if (modalRef.value) { // Check if modalRef exists
        bsModal = new Modal(modalRef.value)
    }
    if (viewModalRef.value) {
        bsViewModal = new Modal(viewModalRef.value)
    }
    fetchDivisi()
    fetchProvince()
})

const closeModal = () => {
    if (bsModal) { // Check if bsModal is initialized
        bsModal.hide()
    }
}

const savePurchaseDestination = async () => {
    loading.value = true; // Indicate loading state
    try {
        if (form.ID) {
            // Update existing purchaseDestination in data data
            await master.postRequest("/purchaseDestination/update", form).then((resp) => {
                if (resp.status === 200) {
                    toast.success('PurchaseDestination updated successfully');
                    closeModal();
                    fetchPurchaseDestinations(); // Re-fetch to update the table view
                } else {
                    toast.error('Failed to update purchaseDestination');
                }
            }).catch((error) => {
                toast.error(error.message || 'Failed to update purchaseDestination');
            })
        } else {
            // Add new purchaseDestination to data data
            await master.postRequest("/purchaseDestination/create", form).then((resp) => {
                if (resp.status === 200) {
                    toast.success('PurchaseDestination created successfully');
                    closeModal();
                    fetchPurchaseDestinations(); // Re-fetch to update the table view
                } else {
                    toast.error('Failed to create purchaseDestination');
                }
            }).catch((error) => {
                toast.error(error.message || 'Failed to create purchaseDestination');
            })
        }
    } catch (error: any) { // Type error
        toast.error(error.message || 'Failed to save purchaseDestination');
    } finally {
        loading.value = false; // End loading state
    }
}

// {{ Define editPurchaseDestination function }}
const editPurchaseDestination = (purchaseDestination: PurchaseDestination) => {
    openModal(purchaseDestination); // Call openModal with the purchaseDestination data
}


// {{ Add type annotation for purchaseDestination parameter }}
const deletePurchaseDestination = async (purchaseDestination: PurchaseDestination) => {
    if (!confirm('Are you sure you want to delete this purchaseDestination?')) return

    loading.value = true; // Indicate loading state
    try {
        // Simulate API call
        await master.postRequest("/purchaseDestination/delete", {ID: purchaseDestination.ID}).then((resp) => {
            if (resp.status === 200) {
                toast.success('PurchaseDestination deleted successfully');
                closeModal();
                fetchPurchaseDestinations(); // Re-fetch to update the table view
            } else {
                toast.error('Failed to delete purchaseDestination');
            }
        })

    } catch (error: any) { // Type error
        toast.error(error.message || 'Failed to delete purchaseDestination');
    } finally {
        loading.value = false; // End loading state
    }
}

// Update openModal to ensure accounts array exists
const openModal = async (purchaseDestination: PurchaseDestination | null = null) => {
    if (purchaseDestination) {
        modalTitle.value = 'Edit PurchaseDestination'
        isEditing.value = true; // Stop watchers

        Object.assign(form, purchaseDestination);

        // Set Divisi (object reference)
        if (purchaseDestination.divisi && divisiOptions.value.length > 0) {
            form.divisi = divisiOptions.value.find((option) => option.ID === (purchaseDestination.divisi.ID || purchaseDestination.divisi)) || null;
            divisiTeamOptions.value = form.divisi.divisiTeams;
        } else {
            form.divisi = null;
            divisiTeamOptions.value = [];
        }

        // Set DivisiTeam (object reference)
        if (purchaseDestination.divisi_team && divisiTeamOptions.value.length > 0) {
            form.divisi_team = divisiTeamOptions.value.find(opt => opt.ID === (purchaseDestination.divisi_team.ID || purchaseDestination.divisi_team)) || null;
        } else {
            form.divisi_team = null;
        }

        // Set Province (string value)
        if (purchaseDestination.province && provinceOptions.value.length > 0) {
            form.province = provinceOptions.value.find(opt => opt.province === purchaseDestination.province)?.province || null;
            await fetchCity(form.province); // Fetch city dat
        } else {
            form.province = null;
        }

        // Set City (string value)
        if (purchaseDestination.city && cityOptions.value.length > 0) {
            form.city = cityOptions.value.find(opt => opt.city === purchaseDestination.city)?.city || null;
            await fetchArea(form.city); // Fetch city data
        } else {
            form.city = null;
        }

        // Set Area (string value)
        if (purchaseDestination.area && areaOptions.value.length > 0) {
            form.area = areaOptions.value.find(opt => opt.area === purchaseDestination.area)?.area || null;
        } else {
            form.area = null;
        }

        isEditing.value = false; // Re-enable watchers after assignments
    } else {
        modalTitle.value = 'Create PurchaseDestination'
        form.ID = null
        form.code= '';
        form.name= '';
        form.divisi= null;
        form.divisi_team= null;
        form.province= null;
        form.city= null;
        form.area= null;
    }
    if (bsModal) {
        bsModal.show()
    }
}

// Watch for divisi changes to update divisiTeamOptions
watch(() => form.divisi, (newDivisi) => {
    if (isEditing.value) return; // Skip watcher logic during editing
    if (newDivisi && newDivisi.divisiTeams) {
        divisiTeamOptions.value = newDivisi.divisiTeams
        form.divisi_team = null // reset selection
    } else {
        divisiTeamOptions.value = []
        form.divisi_team = null
    }
})

// Watch for province changes to fetch cities
watch(() => form.province, async (newProvince) => {
    if (isEditing.value) return; // Skip watcher logic during editing
    if (newProvince && newProvince) {
        await fetchCity(newProvince)
        form.city = null // reset city selection
        areaOptions.value = []
        form.area = null
    } else {
        cityOptions.value = []
        form.city = null
        areaOptions.value = []
        form.area = null
    }
})

// Watch for city changes to fetch areas
watch(() => form.city, async (newCity) => {
    if (isEditing.value) return; // Skip watcher logic during editing
    if (newCity && newCity) {
        await fetchArea(newCity)
        form.area = null // reset area selection
    } else {
        areaOptions.value = []
        form.area = null
    }
})
</script>